export const CityTypeIdEnum = {
  lookupTypeId: 17,
};
